import { render, staticRenderFns } from "./RegisterClienteView.vue?vue&type=template&id=0f63ed4e&"
import script from "./RegisterClienteView.vue?vue&type=script&lang=js&"
export * from "./RegisterClienteView.vue?vue&type=script&lang=js&"
import style0 from "./RegisterClienteView.vue?vue&type=style&index=0&id=0f63ed4e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports